(function () {
  var DISCOUNT_CACHE_PREFIX = 'discount_quotes_v6_';
  var DISCOUNT_SYNC_PREFIX = 'discount_code_synced_';
  var DISCOUNT_REJECTED_PREFIX = 'discount_code_rejected_';
  var DISCOUNT_BACKUP_KEY = 'discount_code_backup';
  var DISCOUNT_CONTEXT_KEY = 'discount_badge_context_v3';
  var DISCOUNT_LANDING_SESSION_KEY = 'discount_landing_session';
  var PROMO_POPUP_DISMISSED_PREFIX = 'discount_promo_popup_dismissed_';
  var PROMO_POPUP_QUIZ_SOURCE_PREFIX = 'discount_promo_opened_quiz_';
  var DISCOUNT_CONTEXT_TTL = 30 * 24 * 60 * 60 * 1000;
  var RUN_DEBOUNCE_MS = 150;
  var QUOTE_RETRY_DELAY_MS = 200;
  var PENDING_AFFILIATE_RETRY_LIMIT = 4;
  var DEFAULT_PROMO_POPUP_TARGET = '#AVNT-quiz';
  var DEFAULT_PROMO_POPUP_FALLBACK_URL = '/pages/nervous-system-impairment-assessment';
  var DEFAULT_PROMO_POPUP_RESUME_DELAY_MS = 10000;
  var TEMPORARY_QUOTE_PROPERTY = '_nuropod_discount_quote';
  var TEMPORARY_QUOTE_STORAGE_KEY = 'nuropod_discount_quote_pending';
  var affiliateConfirmedKeys = [
    'scaaf_aid',
    'scaaf_tid',
    'scaaf_received',
    'up_uppromote_aid',
    'up_uppromote_received',
    '_up_cid'
  ];
  var pendingTimer = null;
  var pendingAffiliateRetryTimer = null;
  var pendingAffiliateRetryCount = 0;
  var pendingDiscountSyncs = {};
  var pendingDiscountQuotes = {};
  var cartQuoteQueue = Promise.resolve();
  var hasAppliedDiscountDisplays = false;
  var discountDisplayRunId = 0;
  var upPromoteEventAffiliateName = '';

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function cartEndpoint(path) {
    return getRoutesRoot() + path.replace(/^\//, '');
  }

  function getCookie(name) {
    var encodedName = encodeURIComponent(name) + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(encodedName) === 0) {
        return decodeURIComponent(part.slice(encodedName.length));
      }
    }

    return '';
  }

  function getStorage(storage, key) {
    try {
      return storage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function setStorage(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in privacy modes. The UI can still run without caching.
    }
  }

  function removeStorage(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Storage can be unavailable in privacy modes.
    }
  }

  function normaliseDiscountCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function getRejectedDiscountKey(code) {
    return DISCOUNT_REJECTED_PREFIX + encodeURIComponent(normaliseDiscountCode(code));
  }

  function isRejectedDiscountCode(code) {
    return Boolean(code && getStorage(sessionStorage, getRejectedDiscountKey(code)) === '1');
  }

  function markRejectedDiscountCode(code) {
    if (code) setStorage(sessionStorage, getRejectedDiscountKey(code), '1');
  }

  function clearRejectedDiscountCode(code) {
    if (code) removeStorage(sessionStorage, getRejectedDiscountKey(code));
  }

  function clearCookie(name) {
    try {
      document.cookie = encodeURIComponent(name) + '=; Max-Age=0; path=/; SameSite=Lax';
    } catch (error) {
      // The rejected-code session marker still prevents the candidate from returning.
    }
  }

  function hasStorageKey(storage, key) {
    return Boolean(getStorage(storage, key));
  }

  function getPopupControls() {
    return window.NuropodPopupControls || {};
  }

  function areAutomaticPopupsDisabled() {
    return getPopupControls().automaticPopupsDisabled === true;
  }

  function isPositiveSignal(value) {
    if (!value) return false;

    var normalisedValue = String(value).toLowerCase();
    return normalisedValue !== '0' && normalisedValue !== 'false' && normalisedValue !== 'null' && normalisedValue !== 'undefined';
  }

  function hasNavigationRedirect() {
    try {
      var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      return Boolean(navigation && navigation.redirectCount > 0);
    } catch (error) {
      return false;
    }
  }

  function getNavigationUrl() {
    try {
      var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      return navigation && navigation.name ? navigation.name : '';
    } catch (error) {
      return '';
    }
  }

  function hasDiscountUrlSignal(value) {
    if (!value) return false;

    return /\/discount\/[^/?#]+/i.test(value)
      || /[?&](discount_code|discount)=/i.test(value)
      || /[?&]view=test-reorder\b/i.test(value)
      || /ig-redirect-session=/i.test(value);
  }

  function hasShopifyDiscountLandingSignal() {
    return hasNavigationRedirect()
      || hasDiscountUrlSignal(window.location.href)
      || hasDiscountUrlSignal(document.referrer)
      || hasDiscountUrlSignal(getNavigationUrl());
  }

  function captureDiscountLandingSession(params, urlCode, cookieCode, scaRef) {
    var hasAffiliateLanding = Boolean(scaRef);
    var hasUrlDiscountLanding = Boolean(urlCode || params.get('discount_code') || params.get('discount'));
    var hasShopifyDiscountRedirect = Boolean(cookieCode && hasShopifyDiscountLandingSignal());

    if (hasAffiliateLanding || hasUrlDiscountLanding || hasShopifyDiscountRedirect) {
      setStorage(sessionStorage, DISCOUNT_LANDING_SESSION_KEY, '1');
    }
  }

  function hasDiscountLandingSession() {
    return getStorage(sessionStorage, DISCOUNT_LANDING_SESSION_KEY) === '1';
  }

  function getStoredContext() {
    try {
      var raw = localStorage.getItem(DISCOUNT_CONTEXT_KEY);
      var context = raw ? JSON.parse(raw) : null;

      if (!context || !context.savedAt) return null;
      if (Date.now() - context.savedAt > DISCOUNT_CONTEXT_TTL) {
        localStorage.removeItem(DISCOUNT_CONTEXT_KEY);
        return null;
      }

      return context;
    } catch (error) {
      return null;
    }
  }

  function setStoredContext(context) {
    try {
      localStorage.setItem(DISCOUNT_CONTEXT_KEY, JSON.stringify({
        code: context.code || '',
        affiliateId: context.affiliateId || '',
        affiliateName: context.affiliateName || '',
        hasAffiliate: Boolean(context.hasAffiliate),
        confirmed: Boolean(context.confirmed),
        pending: Boolean(context.pending),
        hasDiscount: Boolean(context.hasDiscount || context.code),
        popupSource: context.popupSource || '',
        scaRef: context.scaRef || '',
        savedAt: Date.now()
      }));
    } catch (error) {
      // Ignore storage failures; cookies/cart state can still drive the UI.
    }
  }

  function titleCase(value) {
    return value
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }

  function cleanAffiliateName(value) {
    if (!value) return '';

    try {
      value = decodeURIComponent(value);
    } catch (error) {
      // Keep the original value if it is already decoded.
    }

    value = value.replace(/\+/g, ' ').trim();

    return value ? titleCase(value) : '';
  }

  function parseUpPromoteInfo() {
    var raw = getStorage(localStorage, '_up_a_info');
    var parsed = raw;

    if (!raw) return null;

    try {
      parsed = decodeURIComponent(raw);
    } catch (error) {
      // The stored payload may already be decoded.
    }

    for (var attempt = 0; attempt < 2 && typeof parsed === 'string'; attempt += 1) {
      try {
        parsed = JSON.parse(parsed);
      } catch (error) {
        return null;
      }
    }

    return parsed && typeof parsed === 'object' ? parsed : null;
  }

  function getUpPromoteInfoName(info) {
    var nameKeys = [
      'affiliate_name',
      'affiliateName',
      'aff_name',
      'affName',
      'name',
      'first_name',
      'firstName'
    ];
    var queue = info ? [info] : [];
    var visited = [];

    while (queue.length && visited.length < 20) {
      var candidate = queue.shift();

      if (!candidate || typeof candidate !== 'object' || visited.indexOf(candidate) !== -1) continue;
      visited.push(candidate);

      for (var i = 0; i < nameKeys.length; i += 1) {
        var value = candidate[nameKeys[i]];

        if (typeof value === 'string' || typeof value === 'number') {
          var name = cleanAffiliateName(String(value));
          if (name) return name;
        }
      }

      Object.keys(candidate).forEach(function (key) {
        var value = candidate[key];
        if (value && typeof value === 'object') queue.push(value);
      });
    }

    return '';
  }

  function getAffiliateName() {
    return cleanAffiliateName(getCookie('scaaf_affn'))
      || getUpPromoteInfoName(parseUpPromoteInfo())
      || upPromoteEventAffiliateName;
  }

  function getAffiliateSignal() {
    var signal = {
      confirmed: false,
      affiliateId: ''
    };

    affiliateConfirmedKeys.some(function (name) {
      var value = getCookie(name) || getStorage(localStorage, name);
      if (!isPositiveSignal(value)) return false;

      signal.confirmed = true;
      signal.affiliateId = name === 'scaaf_received' || name === 'up_uppromote_received'
        ? ''
        : value;

      return true;
    });

    if (!signal.confirmed && hasStorageKey(localStorage, '__up_exposeActionContext')) {
      signal.confirmed = true;
    }

    return signal;
  }

  function readEventValue(data, keys) {
    var value = '';

    keys.some(function (key) {
      if (data && data[key]) {
        value = data[key];
        return true;
      }

      return false;
    });

    return value;
  }

  function getCartDiscountCode(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return '';

    var applied = cart.discount_codes.find(function (discountCode) {
      return discountCode && discountCode.code && discountCode.applicable !== false;
    });

    return applied ? applied.code : '';
  }

  function buildDiscountContext(data) {
    var code = data.code || '';
    var affiliateId = data.affiliateId || '';
    var scaRef = data.scaRef || '';

    return {
      code: code,
      affiliateId: affiliateId || 'affiliate',
      affiliateName: data.affiliateName || '',
      hasAffiliate: Boolean(data.hasAffiliate),
      confirmed: Boolean(data.confirmed),
      pending: Boolean(data.pending),
      hasDiscount: Boolean(data.hasDiscount || code),
      popupSource: data.popupSource || '',
      scaRef: scaRef,
      key: code || affiliateId || scaRef || 'cart'
    };
  }

  function clearDiscountCandidate(code) {
    var normalisedCode = normaliseDiscountCode(code);
    var storedContext = getStoredContext();

    if (!normalisedCode) return;

    markRejectedDiscountCode(normalisedCode);
    removeStorage(sessionStorage, DISCOUNT_BACKUP_KEY);
    removeStorage(sessionStorage, DISCOUNT_LANDING_SESSION_KEY);
    removeStorage(sessionStorage, getDiscountSyncKey(normalisedCode));
    clearCookie('discount_code');

    if (storedContext) {
      if (storedContext.hasAffiliate || storedContext.scaRef) {
        setStoredContext(buildDiscountContext({
          affiliateId: storedContext.affiliateId || '',
          affiliateName: getAffiliateName(),
          hasAffiliate: Boolean(storedContext.hasAffiliate),
          confirmed: Boolean(storedContext.confirmed),
          pending: Boolean(storedContext.pending),
          hasDiscount: Boolean(storedContext.hasAffiliate),
          popupSource: storedContext.scaRef ? 'affiliate' : '',
          scaRef: storedContext.scaRef || ''
        }));
      } else {
        removeStorage(localStorage, DISCOUNT_CONTEXT_KEY);
      }
    }

    try {
      var currentUrl = new URL(window.location.href);
      var queryCode = currentUrl.searchParams.get('discount_code') || currentUrl.searchParams.get('discount');

      if (normaliseDiscountCode(queryCode) === normalisedCode) {
        currentUrl.searchParams.delete('discount_code');
        currentUrl.searchParams.delete('discount');
        window.history.replaceState(null, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
      }
    } catch (error) {
      // URL cleanup is optional; storage and cookie cleanup are authoritative for this session.
    }
  }

  function getLandingPopupSource(params, urlCode, cookieCode, scaRef, storedContext) {
    if (scaRef) return 'affiliate';
    if (urlCode || params.get('discount_code') || params.get('discount')) return 'code';
    if (cookieCode && hasShopifyDiscountLandingSignal()) return 'code';

    return (storedContext && storedContext.popupSource) || '';
  }

  function getUrlDiscountCode(params) {
    var pathMatch = window.location.pathname.match(/\/discount\/([^/?#]+)/);
    var pathCode = pathMatch ? decodeURIComponent(pathMatch[1]) : '';

    return params.get('discount_code') || params.get('discount') || pathCode;
  }

  function getDiscountContext() {
    var params = new URLSearchParams(window.location.search);
    var storedContext = getStoredContext();
    var cookieCode = getCookie('discount_code');
    var backupCode = getStorage(sessionStorage, DISCOUNT_BACKUP_KEY);
    var urlCode = getUrlDiscountCode(params);
    var code = urlCode || cookieCode || backupCode || (storedContext && storedContext.code) || '';
    var rejectedCode = isRejectedDiscountCode(code);
    var scaRef = params.get('sca_ref') || '';
    var storedScaRef = (storedContext && storedContext.scaRef) || '';
    var affiliateId = scaRef ? scaRef.split('.')[0] : (storedContext && storedContext.affiliateId) || '';
    var affiliateName = getAffiliateName();
    var affiliateSignal = getAffiliateSignal();
    var hasAffiliate = affiliateSignal.confirmed || Boolean(storedContext && storedContext.confirmed && storedContext.hasAffiliate);
    var pendingAffiliate = Boolean(scaRef) || Boolean(storedContext && storedContext.pending);
    var hasDiscount = Boolean(code) || Boolean(storedContext && storedContext.hasDiscount);
    var popupSource = getLandingPopupSource(params, urlCode, cookieCode, scaRef, storedContext);

    if (rejectedCode) {
      code = '';
      cookieCode = '';
      backupCode = '';
      urlCode = '';
      removeStorage(sessionStorage, DISCOUNT_LANDING_SESSION_KEY);
    } else {
      captureDiscountLandingSession(params, urlCode, cookieCode, scaRef);
    }

    var hasActiveAffiliateLanding = Boolean(scaRef) || Boolean(storedScaRef && hasDiscountLandingSession());

    if (hasActiveAffiliateLanding) {
      hasAffiliate = true;
    }

    if (!hasAffiliate && !pendingAffiliate) affiliateName = '';

    hasDiscount = Boolean(code) || hasActiveAffiliateLanding || Boolean(storedContext && storedContext.hasDiscount);

    if (cookieCode || urlCode) {
      setStorage(sessionStorage, DISCOUNT_BACKUP_KEY, urlCode || cookieCode);
    }

    if (!affiliateId && affiliateSignal.affiliateId) affiliateId = affiliateSignal.affiliateId;

    if (!hasDiscount) {
      if (pendingAffiliate || hasAffiliate) {
        setStoredContext(buildDiscountContext({
          affiliateId: affiliateId,
          affiliateName: affiliateName,
          hasAffiliate: hasAffiliate,
          confirmed: hasAffiliate,
          pending: pendingAffiliate && !hasAffiliate,
          popupSource: popupSource,
          scaRef: scaRef || (storedContext && storedContext.scaRef) || ''
        }));
      }

      return null;
    }

    var context = buildDiscountContext({
      code: code,
      affiliateId: affiliateId,
      affiliateName: affiliateName,
      hasAffiliate: hasAffiliate,
      confirmed: hasAffiliate,
      pending: pendingAffiliate && !hasAffiliate,
      hasDiscount: true,
      popupSource: popupSource,
      scaRef: scaRef || (storedContext && storedContext.scaRef) || ''
    });

    if (urlCode || pendingAffiliate || affiliateName || hasAffiliate) {
      setStoredContext(context);
    }

    return context;
  }

  function captureLandingAffiliateContext() {
    var params = new URLSearchParams(window.location.search);
    var scaRef = params.get('sca_ref') || '';

    if (!scaRef) return;

    captureDiscountLandingSession(params, '', '', scaRef);

    var storedContext = getStoredContext() || {};
    var affiliateName = getAffiliateName();

    setStoredContext(buildDiscountContext({
      code: storedContext.code || '',
      affiliateId: storedContext.affiliateId || scaRef.split('.')[0],
      affiliateName: affiliateName,
      hasAffiliate: true,
      confirmed: Boolean(storedContext.confirmed),
      pending: !storedContext.confirmed,
      hasDiscount: true,
      popupSource: 'affiliate',
      scaRef: scaRef
    }));
  }

  function hasPendingAffiliateContext() {
    var params = new URLSearchParams(window.location.search);
    var storedContext = getStoredContext();

    return Boolean(params.get('sca_ref')) || Boolean(storedContext && storedContext.pending);
  }

  function schedulePendingAffiliateRetry() {
    if (
      pendingAffiliateRetryTimer
      || !hasPendingAffiliateContext()
      || pendingAffiliateRetryCount >= PENDING_AFFILIATE_RETRY_LIMIT
    ) {
      return;
    }

    pendingAffiliateRetryCount += 1;
    pendingAffiliateRetryTimer = window.setTimeout(function () {
      pendingAffiliateRetryTimer = null;
      scheduleApply();
    }, pendingAffiliateRetryCount * 750);

  }

  function captureUpPromoteContext(event) {
    var detail = event && event.detail ? event.detail : {};
    var info = detail.info || detail.affiliate || detail.data || {};
    var storedContext = getStoredContext() || {};
    var params = new URLSearchParams(window.location.search);
    var available = detail.available === true || detail.available === 'true' || detail.available === 1;
    var eventAffiliateName = cleanAffiliateName(readEventValue(info, ['affiliate_name', 'affiliateName', 'name', 'first_name', 'firstName']));

    if (!available && !getAffiliateSignal().confirmed) return;

    if (eventAffiliateName) upPromoteEventAffiliateName = eventAffiliateName;

    setStoredContext(buildDiscountContext({
      affiliateId: readEventValue(info, ['affiliate_id', 'affiliateId', 'id', 'aid']) || storedContext.affiliateId || '',
      affiliateName: getAffiliateName(),
      hasAffiliate: true,
      confirmed: true,
      pending: false,
      hasDiscount: true,
      popupSource: params.get('sca_ref') ? 'affiliate' : storedContext.popupSource || 'affiliate',
      scaRef: storedContext.scaRef || params.get('sca_ref') || ''
    }));
    if (pendingAffiliateRetryTimer) {
      window.clearTimeout(pendingAffiliateRetryTimer);
      pendingAffiliateRetryTimer = null;
    }
    pendingAffiliateRetryCount = 0;
  }

  async function getCartDiscountContext() {
    try {
      var cart = await fetchJson(cartEndpoint('/cart.js'));
      var code = getCartDiscountCode(cart);

      if (!code) return null;

      setStorage(sessionStorage, DISCOUNT_BACKUP_KEY, code);

      return buildDiscountContext({
        code: code,
        popupSource: 'code'
      });
    } catch (error) {
      return null;
    }
  }

  function getActiveCurrency(cart, root) {
    if (cart && cart.currency) return cart.currency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return root && root.dataset ? root.dataset.baseCurrency || 'USD' : 'USD';
  }

  function formatMoney(cents, currency) {
    var roundedAmount = Math.round(cents / 100);

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(roundedAmount);
    } catch (error) {
      return roundedAmount + ' ' + currency;
    }
  }

  function getDiscountQuoteConfig() {
    var config = window.NuropodDiscountQuote || {};
    var variantIds = [config.primaryVariantId, config.secondaryVariantId]
      .map(function (variantId) {
        return String(variantId || '').trim();
      })
      .filter(Boolean);

    return {
      enabled: config.enabled === true,
      storefrontAccessToken: String(config.storefrontAccessToken || '').trim(),
      apiVersion: String(config.apiVersion || '2026-07').trim(),
      countryCode: String(config.countryCode || '').trim().toUpperCase(),
      variantIds: variantIds
    };
  }

  function getConfiguredQuoteVariantId(root, providedVariantId) {
    var config = getDiscountQuoteConfig();
    var variantId = String(providedVariantId || (root ? getVariantId(root) : '') || '').trim();

    if (!variantId) return '';
    if (!config.variantIds.length) return '';

    return config.variantIds.indexOf(variantId) !== -1 ? variantId : '';
  }

  function getDefaultQuoteVariantId() {
    var config = getDiscountQuoteConfig();
    return config.variantIds.length ? config.variantIds[0] : '';
  }

  function toStorefrontVariantGid(variantId) {
    var value = String(variantId || '').trim();

    return value.indexOf('gid://') === 0
      ? value
      : 'gid://shopify/ProductVariant/' + value;
  }

  function moneyToCents(money) {
    if (!money || money.amount === undefined) return 0;

    var amount = Number(money.amount);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function getProductInfo(root) {
    return root.closest('product-info') || document;
  }

  function getVariantId(root) {
    var productInfo = getProductInfo(root);
    var variantInput = productInfo.querySelector('form[action*="/cart/add"] input[name="id"]');
    return variantInput && variantInput.value ? variantInput.value : root.dataset.variantId;
  }

  function captureInitialState(root) {
    if (root.dataset.discountInitialised === 'true') return;

    var originalEl = root.querySelector('[data-price-original]');
    var finalEl = root.querySelector('[data-price-final]');

    root.dataset.discountInitialised = 'true';
    if (originalEl) {
      originalEl.dataset.initialText = originalEl.textContent;
      originalEl.dataset.initialClass = originalEl.className;
    }
    if (finalEl) {
      finalEl.dataset.initialText = finalEl.textContent;
      finalEl.dataset.initialClass = finalEl.className;
    }
  }

  function restorePrice(root) {
    var originalEl = root.querySelector('[data-price-original]');
    var finalEl = root.querySelector('[data-price-final]');

    if (originalEl && originalEl.dataset.initialText !== undefined) {
      originalEl.textContent = originalEl.dataset.initialText;
      originalEl.className = originalEl.dataset.initialClass;
    }
    if (finalEl && finalEl.dataset.initialText !== undefined) {
      finalEl.textContent = finalEl.dataset.initialText;
      finalEl.className = finalEl.dataset.initialClass;
    }
  }

  function setStudyApplyVisible(root, visible) {
    var productInfo = getProductInfo(root);

    productInfo.querySelectorAll('.study-apply').forEach(function (el) {
      el.style.display = visible ? '' : 'none';
    });
  }

  function setProductTitleDiscountState(root, active) {
    var productTitle = root.closest('.product-title-heading');

    if (productTitle) productTitle.classList.toggle('product-title-heading--discount-badges', active);
  }

  function hideBadge(root) {
    var badge = root.querySelector('[data-discount-badge]');
    var sitewideBadge = root.querySelector('[data-sitewide-badge]');

    if (badge) badge.classList.add('hidden');

    // No personalised discount or affiliate offer applies — fall back to the
    // always-on sitewide badge (if this price markup renders one) instead of
    // showing nothing.
    if (sitewideBadge) {
      sitewideBadge.classList.remove('hidden');
      setProductTitleDiscountState(root, true);
      return;
    }

    setProductTitleDiscountState(root, false);
  }

  function getAffiliatePillText(meta) {
    var name = meta.affiliateName || '';

    if (!name) return '';

    return getPossessiveName(name) + ' offer is applied';
  }

  function getStorePillText(meta) {
    var code = meta.code || 'store';

    return code + ' applied';
  }

  function getBadgeCopy(meta) {
    if (meta.popupSource === 'affiliate' && meta.affiliateName) {
      return getAffiliatePillText(meta);
    }

    if (meta.popupSource === 'code' && meta.code) {
      return getStorePillText(meta);
    }

    if (meta.code) {
      return getStorePillText(meta);
    }

    if (meta.affiliateName) {
      return getAffiliatePillText(meta);
    }

    return 'Partner offer is applied';
  }

  function getBadgePillTexts(meta) {
    var texts = [];

    if (meta.affiliateName) {
      texts.push(getAffiliatePillText(meta));
    }

    if (meta.code) {
      texts.push(getStorePillText(meta));
    }

    if (!texts.length) {
      texts.push(getBadgeCopy(meta));
    }

    return texts;
  }

  function setBadge(root, meta) {
    var badge = root.querySelector('[data-discount-badge]');
    var sitewideBadge = root.querySelector('[data-sitewide-badge]');

    if (sitewideBadge) sitewideBadge.classList.add('hidden');

    if (!badge) return;

    badge.innerHTML = '';
    getBadgePillTexts(meta).forEach(function (text) {
      var pill = document.createElement('span');
      pill.className = 'promo-discount-badge__pill';
      pill.textContent = text;
      badge.appendChild(pill);
    });

    badge.classList.remove('hidden');
    setProductTitleDiscountState(root, true);
  }

  function getPromoPopupKey(meta) {
    return [
      meta.code || 'affiliate',
      meta.affiliateName || (meta.hasAffiliate ? 'partner' : '')
    ].join('_').replace(/\s+/g, '-').toLowerCase();
  }

  function normalisePromoTarget(target) {
    if (!target) return DEFAULT_PROMO_POPUP_TARGET;

    return target.charAt(0) === '#' ? target : '#' + target;
  }

  function getPromoPopupTarget(popup) {
    return normalisePromoTarget(popup.dataset.discountPromoTarget || DEFAULT_PROMO_POPUP_TARGET);
  }

  function getPromoPopupFallbackUrl(popup) {
    return popup.dataset.discountPromoFallbackUrl || DEFAULT_PROMO_POPUP_FALLBACK_URL;
  }

  function getPromoTargetId(target) {
    return normalisePromoTarget(target).slice(1);
  }

  function isDiscountPromoAutoDisabled(target) {
    var controls = getPopupControls();
    var targetId = getPromoTargetId(target).toLowerCase();

    return controls.automaticPopupsDisabled === true || (controls.avntAnnouncementHidden === true && targetId === 'avnt-quiz');
  }

  function markDiscountPromoQuizSource(target) {
    setStorage(sessionStorage, PROMO_POPUP_QUIZ_SOURCE_PREFIX + getPromoTargetId(target), '1');
  }

  function getPromoQuiz(target) {
    var targetId = getPromoTargetId(target);
    var quizzes = Array.prototype.slice.call(document.querySelectorAll('.pq'));

    return quizzes.find(function (popup) {
      return popup.dataset && popup.dataset.pqTrigger === targetId;
    }) || null;
  }

  function hasPromoTarget(target) {
    var targetId = getPromoTargetId(target);

    return Boolean(getPromoQuiz(target) || document.getElementById(targetId));
  }

  function hasSeenPromoTarget(target) {
    var quiz = getPromoQuiz(target);
    var storageKey = quiz && quiz.dataset ? quiz.dataset.pqStorageKey : '';

    return Boolean(storageKey && getStorage(sessionStorage, storageKey));
  }

  function getPromoTargetDelay(target) {
    var quiz = getPromoQuiz(target);
    var delay = quiz && quiz.dataset ? parseInt(quiz.dataset.pqDelayMs, 10) : DEFAULT_PROMO_POPUP_RESUME_DELAY_MS;

    return Number.isFinite(delay) && delay >= 0 ? delay : DEFAULT_PROMO_POPUP_RESUME_DELAY_MS;
  }

  function openPromoTargetFromDiscount(target, options) {
    var normalisedTarget = normalisePromoTarget(target);

    if (!hasPromoTarget(normalisedTarget)) return false;
    if (options && options.onlyIfUnseen && hasSeenPromoTarget(normalisedTarget)) return false;

    markDiscountPromoQuizSource(normalisedTarget);

    if (window.location.hash === normalisedTarget) {
      var hashEvent;

      try {
        hashEvent = new HashChangeEvent('hashchange');
      } catch (error) {
        hashEvent = new Event('hashchange');
      }

      window.dispatchEvent(hashEvent);
      return true;
    }

    window.location.hash = normalisedTarget;
    return true;
  }

  function schedulePromoTargetFromDiscount(target, options) {
    var normalisedTarget = normalisePromoTarget(target);
    var delay = getPromoTargetDelay(normalisedTarget);

    if (isDiscountPromoAutoDisabled(normalisedTarget)) return false;
    if (options && options.onlyIfUnseen && hasSeenPromoTarget(normalisedTarget)) return false;
    if (delay <= 0) return false;

    window.setTimeout(function () {
      openPromoTargetFromDiscount(normalisedTarget, options);
    }, delay);

    return true;
  }

  function initPromoPopup(popup) {
    var closeButton = popup.querySelector('[data-discount-promo-close]');
    var cta = popup.querySelector('[data-discount-promo-cta]');

    if (popup.dataset.discountPromoInitialised === 'true') return popup;

    popup.dataset.discountPromoInitialised = 'true';

    if (cta) {
      cta.setAttribute('href', getPromoPopupTarget(popup));
      cta.addEventListener('click', function () {
        var target = getPromoPopupTarget(popup);

        markDiscountPromoQuizSource(target);
        dismissPromoPopup(popup, { openPromo: false });

        if (!hasPromoTarget(target)) {
          window.location.href = getPromoPopupFallbackUrl(popup);
        }
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        dismissPromoPopup(popup, { openPromo: true });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.classList.contains('hidden')) {
        dismissPromoPopup(popup, { openPromo: true });
      }
    });

    return popup;
  }

  function getPromoPopup() {
    var popup = document.querySelector('[data-discount-promo-popup]');

    if (popup) return initPromoPopup(popup);

    popup = document.createElement('aside');
    popup.className = 'discount-promo-popup hidden';
    popup.setAttribute('data-discount-promo-popup', '');
    popup.setAttribute('data-discount-promo-target', DEFAULT_PROMO_POPUP_TARGET);
    popup.setAttribute('data-discount-promo-fallback-url', DEFAULT_PROMO_POPUP_FALLBACK_URL);
    popup.setAttribute('data-discount-promo-once-per-session', 'true');
    popup.setAttribute('data-discount-promo-has-content', 'false');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-live', 'polite');
    popup.setAttribute('aria-modal', 'false');
    popup.innerHTML = [
      '<div class="discount-promo-popup__card">',
      '<button type="button" class="discount-promo-popup__close" data-discount-promo-close aria-label="Close discount message">',
      '<span aria-hidden="true">&times;</span>',
      '</button>',
      '<p class="discount-promo-popup__heading" data-discount-promo-heading></p>',
      '</div>'
    ].join('');

    document.body.appendChild(popup);

    return initPromoPopup(popup);
  }

  function dismissPromoPopup(popup, options) {
    var key = popup.dataset.discountPromoKey;
    var target = getPromoPopupTarget(popup);

    if (key && popup.dataset.discountPromoOncePerSession !== 'false') {
      setStorage(sessionStorage, PROMO_POPUP_DISMISSED_PREFIX + key, '1');
    }

    popup.classList.add('hidden');

    if (options && options.openPromo && popup.dataset.discountPromoSuppressQuiz !== 'true') {
      schedulePromoTargetFromDiscount(target, { onlyIfUnseen: true });
    }
  }

  function setPromoPopupContentVisibility(popup, showPromoContent) {
    var heading = popup.querySelector('[data-discount-promo-heading]');
    var body = popup.querySelector('[data-discount-promo-body]');
    var cta = popup.querySelector('[data-discount-promo-cta]');

    popup.dataset.discountPromoSuppressQuiz = showPromoContent ? 'false' : 'true';
    popup.classList.toggle('discount-promo-popup--title-only', !showPromoContent);
    if (heading) {
      heading.style.margin = showPromoContent ? '' : '0';
      heading.style.maxWidth = showPromoContent ? '' : 'none';
    }
    if (body) {
      body.hidden = !showPromoContent;
      body.classList.toggle('hidden', !showPromoContent);
    }
    if (cta) {
      cta.hidden = !showPromoContent;
      cta.classList.toggle('hidden', !showPromoContent);
      cta.setAttribute('aria-hidden', showPromoContent ? 'false' : 'true');
      cta.tabIndex = showPromoContent ? 0 : -1;
    }
  }

  function showPromoPopup(meta) {
    if (!canShowPromoPopup(meta)) return;

    var popup = getPromoPopup();
    var key = getPromoPopupKey(meta);
    var heading = popup.querySelector('[data-discount-promo-heading]');
    var target = getPromoPopupTarget(popup);
    var showPromoContent = popup.dataset.discountPromoHasContent === 'true' && !hasSeenPromoTarget(target);

    popup.dataset.discountPromoKey = key;
    setPromoPopupContentVisibility(popup, showPromoContent);
    if (heading) heading.textContent = getBadgeCopy(meta);
    popup.classList.remove('hidden');
  }

  function canShowPromoPopup(meta) {
    if (!meta || (!meta.code && !meta.affiliateName && meta.popupSource !== 'affiliate')) return false;
    if (!hasDiscountLandingSession()) return false;
    if (areAutomaticPopupsDisabled()) return false;

    var popup = document.querySelector('[data-discount-promo-popup]');
    var target = popup ? getPromoPopupTarget(popup) : DEFAULT_PROMO_POPUP_TARGET;
    var key = getPromoPopupKey(meta);

    if (isDiscountPromoAutoDisabled(target)) return false;
    if (popup && popup.dataset.discountPromoEnabled === 'false') return false;
    if (popup && popup.dataset.discountPromoAutomaticDisabled === 'true') return false;
    if (
      popup
      && popup.dataset.discountPromoOncePerSession !== 'false'
      && getStorage(sessionStorage, PROMO_POPUP_DISMISSED_PREFIX + key)
    ) {
      return false;
    }

    return true;
  }

  function getPossessiveName(name) {
    return /s$/i.test(name) ? name + "'" : name + "'s";
  }

  function getPriceCacheKey(variantId, discountContext, currency) {
    return [
      DISCOUNT_CACHE_PREFIX,
      variantId || 'variant',
      discountContext.key,
      discountContext.hasAffiliate ? 'affiliate' : 'no-affiliate',
      discountContext.affiliateId || 'no-affiliate-id',
      getDiscountQuoteConfig().countryCode || 'no-country',
      currency
    ].join('_');
  }

  function getCachedResult(cacheKey) {
    try {
      var value = sessionStorage.getItem(cacheKey);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function setCachedResult(cacheKey, result) {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(result));
    } catch (error) {
      // Ignore cache write failures.
    }
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options);
    if (!response.ok) throw new Error('Request failed: ' + response.status);
    return response.json();
  }

  async function fetchStorefrontGraphql(query, variables) {
    var config = getDiscountQuoteConfig();
    var endpoint = window.location.origin + '/api/' + encodeURIComponent(config.apiVersion) + '/graphql.json';
    var headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    if (config.storefrontAccessToken) {
      headers['X-Shopify-Storefront-Access-Token'] = config.storefrontAccessToken;
    }

    var response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: query,
        variables: variables
      })
    });

    if (!response.ok) throw new Error('Storefront quote failed: ' + response.status);

    return response.json();
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  async function applyDiscountCodeToCart(code) {
    if (!code) return;

    try {
      var response = await fetch(cartEndpoint('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js'), {
        credentials: 'same-origin'
      });
      return response.ok;
    } catch (error) {
      // The following cart read can still succeed if Shopify has already applied the code.
    }

    return false;
  }

  function getDiscountSyncKey(code) {
    return DISCOUNT_SYNC_PREFIX + encodeURIComponent(String(code || '').trim().toUpperCase());
  }

  function queueDiscountCodeSync(code) {
    var normalisedCode = String(code || '').trim();
    var syncKey;

    if (!normalisedCode) return;

    syncKey = getDiscountSyncKey(normalisedCode);
    if (pendingDiscountSyncs[syncKey] || getStorage(sessionStorage, syncKey) === '1') return;

    pendingDiscountSyncs[syncKey] = true;

    var sync = function () {
      applyDiscountCodeToCart(normalisedCode).then(function (synced) {
        if (synced) setStorage(sessionStorage, syncKey, '1');
      }).finally(function () {
        delete pendingDiscountSyncs[syncKey];
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(sync, { timeout: 1500 });
    } else {
      window.setTimeout(sync, 0);
    }
  }

  function setCartQuoteLoading(loading) {
    document.querySelectorAll('.product-form__submit, button[name="add"]').forEach(function (button) {
      if (loading) {
        if (button.dataset.discountQuoteWasDisabled !== undefined) return;
        button.dataset.discountQuoteWasDisabled = button.disabled ? 'true' : 'false';
        button.dataset.discountQuoteAriaDisabled = button.getAttribute('aria-disabled') || '';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        return;
      }

      if (button.dataset.discountQuoteWasDisabled === undefined) return;
      button.disabled = button.dataset.discountQuoteWasDisabled === 'true';
      if (button.dataset.discountQuoteAriaDisabled) {
        button.setAttribute('aria-disabled', button.dataset.discountQuoteAriaDisabled);
      } else {
        button.removeAttribute('aria-disabled');
      }
      delete button.dataset.discountQuoteWasDisabled;
      delete button.dataset.discountQuoteAriaDisabled;
    });
  }

  function queueCartQuote(callback) {
    var queued = cartQuoteQueue.then(callback, callback);
    cartQuoteQueue = queued.catch(function () {});
    return queued;
  }

  function waitForPendingCartQuote() {
    return cartQuoteQueue;
  }

  function getTemporaryQuoteLine(cart, quoteId) {
    return cart && Array.isArray(cart.items) ? cart.items.find(function (item) {
      var value = item.properties && item.properties[TEMPORARY_QUOTE_PROPERTY];
      return value && (!quoteId || value === quoteId);
    }) : null;
  }

  async function removeTemporaryQuoteLines(quoteId) {
    for (var attempt = 0; attempt < 5; attempt += 1) {
      var cart = await fetchJson(cartEndpoint('/cart.js'), { credentials: 'same-origin' });
      var line = getTemporaryQuoteLine(cart, quoteId);

      if (!line) return true;

      await fetchJson(cartEndpoint('/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
    }

    return false;
  }

  async function removeTemporaryQuoteLine(quoteId, lineKey) {
    if (lineKey) {
      try {
        var cart = await fetchJson(cartEndpoint('/cart/change.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        });

        if (!getTemporaryQuoteLine(cart, quoteId)) return true;
      } catch (error) {
        // A discount can change the line key; fall back to the private property lookup.
      }
    }

    return removeTemporaryQuoteLines(quoteId);
  }

  function cleanupAbandonedCartQuote() {
    var quoteId = getStorage(localStorage, TEMPORARY_QUOTE_STORAGE_KEY);

    if (!quoteId) return Promise.resolve(true);

    return queueCartQuote(async function () {
      var cleaned = false;

      setCartQuoteLoading(true);
      try {
        cleaned = await removeTemporaryQuoteLines(quoteId);
        if (cleaned) removeStorage(localStorage, TEMPORARY_QUOTE_STORAGE_KEY);
        return cleaned;
      } finally {
        setCartQuoteLoading(false);
      }
    });
  }

  function getAjaxCartLineResult(cart, line, discountContext, storefrontResult) {
    var original = Number(line.original_line_price || 0);
    var discount = (line.discounts || []).reduce(function (total, allocation) {
      return total + Number(allocation.amount || 0);
    }, 0);
    var final = Math.max(0, original - discount);
    var currency = getActiveCurrency(cart);
    var affiliateConfirmed = Boolean(original && final < original);

    if (discountContext.code) {
      affiliateConfirmed = Boolean(
        affiliateConfirmed
        && storefrontResult
        && storefrontResult.status === 'confirmed'
        && storefrontResult.currency === currency
        && final < storefrontResult.final
      );
    }

    return Object.assign({}, storefrontResult || {}, {
      status: 'confirmed',
      applicable: true,
      original: original,
      final: final,
      currency: currency,
      code: (storefrontResult && storefrontResult.code) || discountContext.code || '',
      hasLineDiscount: Boolean(original && final < original),
      affiliateConfirmed: affiliateConfirmed,
      cartCalculated: true
    });
  }

  async function fetchAffiliateCartQuote(discountContext, variantId, storefrontResult) {
    return queueCartQuote(async function () {
      var quoteId = Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
      var abandonedQuoteId = getStorage(localStorage, TEMPORARY_QUOTE_STORAGE_KEY);
      var quoteResult = null;
      var quoteLineKey = '';
      var addStarted = false;
      var cleaned = !abandonedQuoteId;

      try {
        if (abandonedQuoteId) {
          setCartQuoteLoading(true);
          if (!await removeTemporaryQuoteLines(abandonedQuoteId)) throw new Error('Temporary cart quote cleanup failed');
          cleaned = true;
          removeStorage(localStorage, TEMPORARY_QUOTE_STORAGE_KEY);
          setCartQuoteLoading(false);
        }

        if (discountContext.code) {
          if (!await applyDiscountCodeToCart(discountContext.code)) {
            throw new Error('Discount code cart sync failed');
          }
          setStorage(sessionStorage, getDiscountSyncKey(discountContext.code), '1');
        }

        setStorage(localStorage, TEMPORARY_QUOTE_STORAGE_KEY, quoteId);
        setCartQuoteLoading(true);
        addStarted = true;

        var added = await fetchJson(cartEndpoint('/cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1,
              properties: { [TEMPORARY_QUOTE_PROPERTY]: quoteId }
            }]
          })
        });
        var addedLine = added.items && added.items.find(function (item) {
          return item.properties && item.properties[TEMPORARY_QUOTE_PROPERTY] === quoteId;
        });

        if (addedLine) {
          quoteLineKey = addedLine.key || '';
          quoteResult = getAjaxCartLineResult(
            { currency: getActiveCurrency() },
            addedLine,
            discountContext,
            storefrontResult
          );
        }

        if (!(quoteResult && quoteResult.affiliateConfirmed)) {
          await wait(200);
          var cart = await fetchJson(cartEndpoint('/cart.js'), { credentials: 'same-origin' });
          var line = getTemporaryQuoteLine(cart, quoteId);

          if (!line) throw new Error('Temporary cart quote line missing');

          quoteLineKey = line.key;
          quoteResult = getAjaxCartLineResult(cart, line, discountContext, storefrontResult);
        }
      } finally {
        try {
          if (addStarted) cleaned = await removeTemporaryQuoteLine(quoteId, quoteLineKey);
          if (cleaned) removeStorage(localStorage, TEMPORARY_QUOTE_STORAGE_KEY);
        } finally {
          setCartQuoteLoading(false);
        }
      }

      if (!cleaned || !quoteResult || !quoteResult.affiliateConfirmed) {
        throw new Error('Affiliate discount was not confirmed by Shopify');
      }

      return quoteResult;
    });
  }

  async function fetchStorefrontDiscountQuote(root, discountContext, providedVariantId) {
    var config = getDiscountQuoteConfig();
    var variantId = getConfiguredQuoteVariantId(root, providedVariantId);
    var activeCode = (discountContext && discountContext.code) || getCookie('discount_code') || getStorage(sessionStorage, DISCOUNT_BACKUP_KEY);
    var cartFields = [
      'id',
      'discountCodes { code applicable }',
      'lines(first: 1) {',
      '  nodes {',
      '    merchandise {',
      '      ... on ProductVariant { id }',
      '    }',
      '    cost {',
      '      subtotalAmount { amount currencyCode }',
      '      totalAmount { amount currencyCode }',
      '    }',
      '    discountAllocations {',
      '      discountedAmount { amount currencyCode }',
      '      ... on CartCodeDiscountAllocation { code }',
      '    }',
      '  }',
      '}'
    ].join('\n');
    var query = [
      'mutation DiscountQuote($input: CartInput!) {',
      '  cartCreate(input: $input) {',
      '    cart {' + cartFields + '}',
      '    userErrors { field message }',
      '    warnings { code message target }',
      '  }',
      '}'
    ].join('\n');
    var data;
    var cart;
    var line;
    var original;
    var final;
    var discountAmount = 0;
    var code = activeCode;
    var warnings = [];
    var discountCodes = [];
    var applicableDiscount;

    if (!config.enabled || !variantId || !activeCode) {
      return { status: 'failed', code: activeCode || '' };
    }

    var input = {
      lines: [{
        merchandiseId: toStorefrontVariantGid(variantId),
        quantity: 1
      }],
      discountCodes: [activeCode],
      buyerIdentity: config.countryCode ? { countryCode: config.countryCode } : undefined
    };

    data = await fetchStorefrontGraphql(query, { input: input });

    if (data.errors || !data.data || !data.data.cartCreate) {
      throw new Error('Storefront quote returned no cartCreate result');
    }
    if (data.data.cartCreate.userErrors && data.data.cartCreate.userErrors.length) {
      throw new Error('Storefront quote returned user errors');
    }

    cart = data.data.cartCreate.cart;
    warnings = data.data.cartCreate.warnings || [];
    if (!cart || !cart.lines || !cart.lines.nodes || !cart.lines.nodes.length) {
      throw new Error('Storefront quote returned no merchandise line');
    }

    discountCodes = Array.isArray(cart.discountCodes) ? cart.discountCodes : [];
    applicableDiscount = discountCodes.find(function (discountCode) {
      return discountCode
        && normaliseDiscountCode(discountCode.code) === normaliseDiscountCode(activeCode)
        && discountCode.applicable === true;
    });

    if (!applicableDiscount) {
      return {
        status: 'invalid',
        applicable: false,
        code: activeCode,
        warnings: warnings,
        storefrontCalculated: true
      };
    }

    code = applicableDiscount.code || code;

    line = cart.lines.nodes[0];
    if (!line.merchandise || line.merchandise.id !== toStorefrontVariantGid(variantId)) {
      throw new Error('Storefront quote returned a different merchandise variant');
    }
    if (!line.cost || !line.cost.subtotalAmount || !line.cost.totalAmount) {
      throw new Error('Storefront quote returned invalid line cost');
    }
    original = moneyToCents(line.cost && line.cost.subtotalAmount);
    final = moneyToCents(line.cost && line.cost.totalAmount);

    if (Array.isArray(line.discountAllocations)) {
      line.discountAllocations.forEach(function (allocation) {
        discountAmount += moneyToCents(allocation && allocation.discountedAmount);
      });
    }

    if (discountAmount > 0 && original > 0) {
      final = Math.max(0, original - discountAmount);
    }

    return {
      status: 'confirmed',
      applicable: true,
      original: original,
      final: final,
      currency: line.cost && line.cost.totalAmount && line.cost.totalAmount.currencyCode
        ? line.cost.totalAmount.currencyCode
        : getActiveCurrency(null, root),
      code: code,
      hasLineDiscount: Boolean(original && final < original),
      warnings: warnings,
      storefrontCalculated: true
    };
  }

  async function fetchDiscountQuote(root, discountContext, variantId) {
    var result = null;

    if (!getDiscountQuoteConfig().enabled) {
      return { status: 'failed', code: discountContext.code || '' };
    }

    if (discountContext.code) {
      try {
        result = await fetchStorefrontDiscountQuote(root, discountContext, variantId);
      } catch (error) {
        await wait(QUOTE_RETRY_DELAY_MS);
        result = await fetchStorefrontDiscountQuote(root, discountContext, variantId);
      }

      if (!result || result.status !== 'confirmed' || !discountContext.hasAffiliate) return result;
    }

    if (!discountContext.hasAffiliate) {
      return result || { status: 'failed', code: discountContext.code || '' };
    }

    try {
      return await fetchAffiliateCartQuote(discountContext, variantId, result);
    } catch (error) {
      if (discountContext.code && result && result.status === 'confirmed') {
        return Object.assign({}, result, { affiliateConfirmed: false });
      }
      return { status: 'failed', code: discountContext.code || '' };
    }
  }

  async function getDiscountQuote(root, discountContext, providedVariantId) {
    var variantId = getConfiguredQuoteVariantId(root, providedVariantId);
    var currency = getActiveCurrency(null, root || document.documentElement);
    var cacheKey = getPriceCacheKey(variantId, discountContext, currency);
    var cached = getCachedResult(cacheKey);
    var result;

    if (!variantId) return { status: 'failed', code: discountContext.code || '' };
    if (cached && (cached.status === 'confirmed' || cached.status === 'invalid')) return cached;
    if (pendingDiscountQuotes[cacheKey]) return pendingDiscountQuotes[cacheKey];

    pendingDiscountQuotes[cacheKey] = fetchDiscountQuote(root, discountContext, variantId);

    try {
      result = await pendingDiscountQuotes[cacheKey];
    } catch (error) {
      result = { status: 'failed', code: discountContext.code || '' };
    } finally {
      delete pendingDiscountQuotes[cacheKey];
    }

    if (result && (
      result.status === 'invalid'
      || (result.status === 'confirmed' && (!discountContext.hasAffiliate || result.affiliateConfirmed !== false))
    )) {
      setCachedResult(cacheKey, result);
    }

    return result || { status: 'failed', code: discountContext.code || '' };
  }

  function updatePriceDisplay(root, result) {
    if (!result || result.final >= result.original) return false;

    var originalEl = root.querySelector('[data-price-original]');
    var finalEl = root.querySelector('[data-price-final]');

    if (!originalEl || !finalEl) return false;

    originalEl.textContent = formatMoney(result.original, result.currency);
    originalEl.classList.remove('hidden');
    originalEl.classList.add('strike');
    finalEl.textContent = formatMoney(result.final, result.currency);
    finalEl.classList.remove('hidden');

    return true;
  }

  function buildBadgeMeta(discountContext, result) {
    return {
      code: result && result.code ? result.code : discountContext.code,
      affiliateName: result && result.affiliateConfirmed === false ? '' : discountContext.affiliateName,
      popupSource: discountContext.popupSource || ''
    };
  }

  async function applyRoot(root, discountContext, runId) {
    var result = null;
    var meta;

    captureInitialState(root);
    restorePrice(root);
    hideBadge(root);
    setStudyApplyVisible(root, true);

    if (discountContext.code || discountContext.hasAffiliate) {
      result = await getDiscountQuote(root, discountContext);
      if (runId !== discountDisplayRunId) return null;

      if (!result || result.status === 'failed') return null;
      if (result.status === 'invalid') {
        if (discountContext.code) clearDiscountCandidate(discountContext.code);
        return null;
      }

      if (discountContext.code) clearRejectedDiscountCode(discountContext.code);
      updatePriceDisplay(root, result);
      meta = buildBadgeMeta(discountContext, result);
      setBadge(root, meta);
      return meta;
    }

    return null;
  }

  async function getPopupMetaWithoutRoot(discountContext, runId) {
    var result = await getDiscountQuote(null, discountContext, getDefaultQuoteVariantId());

    if (runId !== discountDisplayRunId) return null;
    if (!result || result.status === 'failed') return null;
    if (result.status === 'invalid') {
      if (discountContext.code) clearDiscountCandidate(discountContext.code);
      return null;
    }

    if (discountContext.code) clearRejectedDiscountCode(discountContext.code);
    return buildBadgeMeta(discountContext, result);
  }

  function hidePromoPopup() {
    var popup = document.querySelector('[data-discount-promo-popup]');
    if (popup) popup.classList.add('hidden');
  }

  async function applyDiscountDisplays() {
    var runId = ++discountDisplayRunId;
    var discountContext = getDiscountContext();
    var roots = document.querySelectorAll('[data-discount-price-root]');
    var rootPromises = [];
    var metas;
    var popupMeta;

    hidePromoPopup();

    try {
      await cleanupAbandonedCartQuote();
    } catch (error) {
      // Keep the pending marker so the next run can retry cleanup.
    }
    if (runId !== discountDisplayRunId) return;

    if (!discountContext) {
      discountContext = await getCartDiscountContext();
    }

    if (!discountContext) {
      schedulePendingAffiliateRetry();
    }

    roots.forEach(function (root) {
      captureInitialState(root);

      if (!discountContext) {
        restorePrice(root);
        hideBadge(root);
        setStudyApplyVisible(root, true);
        schedulePendingAffiliateRetry();
        return;
      }

      rootPromises.push(applyRoot(root, discountContext, runId));
    });

    if (!discountContext) return;

    metas = await Promise.all(rootPromises);
    if (runId !== discountDisplayRunId) return;

    popupMeta = metas.find(Boolean) || null;
    if (!roots.length) popupMeta = await getPopupMetaWithoutRoot(discountContext, runId);
    if (runId !== discountDisplayRunId) return;
    if (!popupMeta) {
      if (discountContext.pending) schedulePendingAffiliateRetry();
      return;
    }

    if (popupMeta.code) queueDiscountCodeSync(popupMeta.code);
    showPromoPopup(popupMeta);
  }

  function scheduleApply() {
    var delay = hasAppliedDiscountDisplays ? RUN_DEBOUNCE_MS : 0;

    if (pendingTimer) window.clearTimeout(pendingTimer);

    pendingTimer = window.setTimeout(function () {
      pendingTimer = null;
      hasAppliedDiscountDisplays = true;
      applyDiscountDisplays();
    }, delay);
  }

  function clearDiscountCache() {
    try {
      Object.keys(sessionStorage).forEach(function (key) {
        if (key.indexOf(DISCOUNT_CACHE_PREFIX) === 0) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (error) {
      // Ignore cache cleanup failures.
    }
  }

  captureLandingAffiliateContext();
  window.NuropodDiscountProbeReady = waitForPendingCartQuote;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApply);
  } else {
    scheduleApply();
  }

  window.addEventListener('pageshow', scheduleApply);
  window.addEventListener('uppromote:tracked-affiliate', function (event) {
    captureUpPromoteContext(event);
    clearDiscountCache();
    scheduleApply();
  });

  document.addEventListener('shopify:currency:update', function () {
    clearDiscountCache();
    scheduleApply();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      clearDiscountCache();
      scheduleApply();
    });
  }
})();
